import { get } from 'lodash';

export const appItemsSelector = state => get( state, 'apps.appItems', [] );
